import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BlockType, Category, IMG_SIZE, PAGE_CONTENT, PageContent, SubCategories } from '../../shared/content';
import { combineLatest, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-item-property',
  templateUrl: './sub-category.component.html',
  styleUrls: ['./sub-category.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubCategoryComponent {
  public categoryData$: Observable<SubCategories>;
  public blockType: typeof BlockType = BlockType;
  public imgSize: typeof IMG_SIZE = IMG_SIZE;
  public footerNavigation: Array<SubCategories> = [null, null];
  public startNumberListAt: number = 1;

  constructor(private route: ActivatedRoute,
              private sanitizer: DomSanitizer) {
    this.categoryData$ = combineLatest(this.route.params, this.route.parent.params)
      .pipe(
        map(([param, parentParam]: [{ item: string }, { id: string }]) => {
          const itemPage = PAGE_CONTENT.find((category: Category) => category.url === parentParam.id);
          const pageContent = itemPage.pageContent
            .find((el: PageContent) => !!el.categories.some((cat: SubCategories) => cat.categoriesUrl === param.item));
          return pageContent && pageContent.categories.find((cat: SubCategories, index: number) => {
            if (cat.categoriesUrl === param.item) {
              this.footerNavigation = [
                index === 0 ? null : pageContent.categories[index - 1],
                index === pageContent.categories.length ? null : pageContent.categories[index + 1]
              ];
              return true;
            }

            return false;
          }) || null;
        }),
        tap((subCategories: SubCategories) => {
          if (!subCategories) {
            this.footerNavigation = [null, null];
          }
        })
      );
  }

  trustResourceUrl(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

